import { DSHead } from 'shared-definitions/types'
import { ApiHeadProps } from 'data-source/types.wp'

export function headPropsMapper(input: ApiHeadProps): DSHead {
  return {
    metaTitle: input.meta_title,
    metaTags: Object.values(input.meta),
    jsonLd: input.json_ld ?? [],
  }
}
